let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5IuQb"), load("joJy8"), load("aHE9G"), load("c6MKV"), load("bKvoJ")]).then(() => parcelRequire('aFK6m'));